import gql from 'graphql-tag'

export default config => {
  const { client } = config

  return {
    fetchAll: async function () {
      const query = gql`
        query {
          items: vw_used_item_tags {
            tag
          }
        }
      `
      const {
        data: { items }
      } = await client.query({
        query
      })

      return items.map(x => x.tag)
    }
  }
}
